//
// locale_eu.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/eu.json';
import localeData from "react-intl/locale-data/eu.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
